export class CategoryKnowledgeAlreadyExistsError extends Error { }
